import React from 'react';
import LayoutHomepage from '../layout/LayoutHomepage';
import DrinkFood from '../assets/images/drink-food-home.svg';
import AwesomeCity from '../assets/icons/Icon-awesome-city.svg';
import LocationCity from '../assets/icons/Icon-material-location.svg';
import { Link } from 'react-router-dom';

const Welcome = () => {
  return (
    <LayoutHomepage>
      <div className="flex max-w-screen-xl px-8 lg:px-12 mx-auto w-full mt-32">
        <div className=" flex py-12">
          <div className="flex flex-col w-6/12 ">
            <h1 className="text-basic-orange tracking-0-78 text-4xl font-semibold">
              Belanja Online dari Rumah di bikin simple
            </h1>
            <img src={DrinkFood} className="w-11/12 self-end" alt="" />
          </div>
          <div className="flex w-6/12 ">
            <div className="flex flex-col w-full py-8 max-w-md ml-auto">
              <div className="bg-green-500 py-4 px-8 rounded-md text-center mt-12">
                <h3 className="text-white text-2xl">
                  Pertama, mari pilih area di kota mu
                </h3>
              </div>
              <div className="bg-white rounded-b-md flex px-8 py-8">
                <div className="flex w-full  justify-evenly">
                  <Link
                    to="/homepage"
                    className="max-w-md flex flex-col justify-center mx-4"
                  >
                    <img src={AwesomeCity} alt="" className="h-16" />
                    <p className="mt-4">Kota Malang</p>
                  </Link>
                  <Link
                    to="/homepage"
                    className="max-w-md flex flex-col justify-center mx-4"
                  >
                    <img src={LocationCity} className="h-16" alt="" />
                    <p className="mt-4">Kota Surabaya</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutHomepage>
  );
};

export default Welcome;
